module.exports = __webpack_public_path__ + "img/indexblock_bg.a06c7264.png";